module.exports = __webpack_public_path__ + "img/icon-communication-active.ca24646b.svg";